module.exports = __webpack_public_path__ + "static/DHCM4-56a06966f103753fdc83c8cf20a5a7ed.jpg";